import { Button } from "antd";
import { useState } from "preact/compat";
import { ContactModal } from "../presentation/ContactModal";

import styles from "./ContactModalContainer.module.css";

export const ContactModalContainer = () => {
  const [isOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  return (
    <div>
      <Button className={styles.button} onClick={showModal}>Связаться</Button>
      {isOpen && <ContactModal isOpen={isOpen} close={handleCancel} />}
    </div>
  );
};
